<template>
  <div class="cargo-details">
    <div class="title">Cargo Details</div>

    <validation-observer name="Cargo" ref="validateCargo">
      <div v-for="item in value.showAddMore" :key="item.id">
        <b-card class="b-card-bg">
          <div v-if="item.hasDelete && !readonly" class="custom-delete">
            <b-img
              width="35px"
              @click="handleDeleteCargo(item.id)"
              :src="iconRemove"
              alt="logo"
            />
          </div>
          <b-row class="px-2">
            <b-col
              cols="12"
              lg="12"
              v-for="item2 in item.showAddMoreLine"
              :key="item2.id"
            >
              <b-row>
                <b-col class="custom-grid">
                  <validation-provider
                    name="No. of packages"
                    #default="{ errors }"
                    rule="required|minNumber:0"
                  >
                    <b-form-group>
                      <label class="flex"
                        >No. of packages
                        <div class="red">*</div>
                      </label>

                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="item2.packages"
                        type="number"
                        placeholder="No. of packages"
                        required
                        @input="updatePackages(item)"
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Package type"
                    #default="{ errors }"
                    rule="required"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Package type
                        <div class="red">*</div></label
                      >

                      <Select2
                        :disabled="readonly"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        placeholder="Package type"
                        v-model="item2.package_type"
                        :options="
                          cont_types.filter((i) => i.group === 'packaging')
                        "
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name=" Gross weight"
                    #default="{ errors }"
                    rule="required|minNumber:0"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Gross weight (kgs)
                        <div class="red">*</div>
                      </label>

                      <b-form-input
                        :disabled="readonly"
                        class="iuput"
                        v-model="item2.gross_weight"
                        type="number"
                        placeholder="Gross weight (kgs)"
                        required
                        @input="updateGrossWeight(item)"
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <validation-provider
                    name="Volume"
                    #default="{ errors }"
                    rule="required|minNumber:0"
                  >
                    <b-form-group>
                      <label class="flex"
                        >Volume (cbm)
                        <div class="red">*</div>
                      </label>

                      <b-form-input
                        :disabled="readonly"
                        @input="updateVolume(item)"
                        v-model="item2.volume"
                        class="iuput"
                        type="number"
                        placeholder="Volume (cbm)"
                        required
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col class="custom-grid">
                  <div class="flex">
                    <label>Dimension (cm)</label>

                    <validation-provider
                      name="Dimension"
                      #default="{ errors }"
                      rules="minNumber:0"
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="item2.dimension.lenght"
                          type="number"
                          placeholder="L (cm)"
                          required
                        ></b-form-input>

                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>


                    <validation-provider
                      name="Dimension"
                      #default="{ errors }"
                      rules="minNumber:0"
                    >
                      <b-form-group>
                        <b-form-input
                          :disabled="readonly"
                          class="iuput"
                          v-model="item2.dimension.width"
                          type="number"
                          placeholder="W (cm)"
                          required
                        ></b-form-input>

                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
                <b-col class="flex items-center mt-10">
                  <div
                    v-if="!item2.hasDelete && !readonly"
                    class="custom-add-line"
                  >
                    <b-img
                      @click="handleAddLine(item.id)"
                      width="30px"
                      :src="iconAdd"
                      alt="logo"
                    />
                  </div>
                  <div
                    v-if="item2.hasDelete && !readonly"
                    class="custom-add-line"
                  >
                    <b-img
                      width="30px"
                      :src="remove"
                      @click="handleDeleteLine(item.id, item2.id)"
                      alt="logo"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col class="custom-grid">
              <validation-provider
                name="Commodity type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label class="flex"
                    >Commodity type <span class="red">*</span></label
                  >
                  <!-- goods_type -->
                  <Select2
                    :disabled="readonly"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Commodity"
                    v-model="item.commodity_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="custom-grid">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label class="flex"
                    >Commodity <span class="red">*</span></label
                  >
                  <!-- mo_ta -->
                  <b-form-input
                    :disabled="readonly"
                    class="iuput"
                    v-model="item.commodity"
                    type="text"
                    placeholder="Commodity"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="custom-grid">
              <validation-provider name="Total packages" #default="{ errors }">
                <b-form-group>
                  <label class="flex"
                    >Total packages <span class="red">*</span></label
                  >
                  <!-- 
                                <b-form-input
                                :disabled="readonly"
                                    value="12"
                                    class="iuput"
                                    disabled="true"
                                    v-model="search"
                                    type="text"
                                    placeholder="0"
                                    required
                                ></b-form-input> -->
                  <div class="customTotal">
                    {{ item.total_packages.toLocaleString() }}
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="custom-grid">
              <validation-provider
                name="Total gross weight"
                #default="{ errors }"
              >
                <b-form-group>
                  <label class="flex"
                    >Total gross weight (kgs) <span class="red">*</span></label
                  >
                  <div class="customTotal">
                    {{ item.gross_weight_total.toLocaleString() }}
                  </div>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="custom-grid">
              <validation-provider name="Total volume" #default="{ errors }">
                <b-form-group>
                  <label class="flex"
                    >Total volume (cbm) <span class="red">*</span></label
                  >
                  <div class="customTotal">
                    {{ item.volume_total.toLocaleString() }}
                  </div>

                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </validation-observer>
    <!-- <b-card class="add-more-cargo" v-if="!this.readonly">
            <div @click="handleAddCargo" class="select-add">
                <div class="flex items-center">
                    <b-img width="30px" :src="iconAdd" alt="logo" />
                    <div class="mx-1">Add more cargo</div>
                </div>
            </div>
        </b-card> -->
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import { BFormGroup, BRow, BCol, BTable, BCard } from "bootstrap-vue";

export default {
  components: {
    Select2,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BTable,
    BCard,
  },
  data() {
    return {
      iconAdd: require("@/assets/images/icons/add.png"),
      iconRemove: require("@/assets/images/icons/iconRemove.png"),
      remove: require("@/assets/images/icons/remove.png"),
      showAddMore: [
        {
          id: 1,
          hasDelete: false,
          showAddMoreLine: [
            {
              id: 2,
              hasDelete: false,
              gross_weight: null,
              volume: null,
              packages: null,

              dimension: {
                lenght: null,
                width: null,
                height: null,
              },
            },
          ],
          total_packages: 0,
          gross_weight_total: 0,
          volume_total: 0,
          commodity_type: null,
          commodity: null,
        },
      ],
    };
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
    ]),
  },
  methods: {
    updateVolume(items) {
      const index = this.value.showAddMore.findIndex((item) => item === items);
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].volume) + Number(total);
      }
      this.value.showAddMore[index].volume_total = total;
    },
    updateGrossWeight(items) {
      const index = this.value.showAddMore.findIndex((item) => item === items);
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].gross_weight) + Number(total);
      }
      this.value.showAddMore[index].gross_weight_total = total;
    },
    updatePackages(items) {
      const index = this.value.showAddMore.findIndex((item) => item === items);
      let total = 0;
      for (let i = 0; i < items.showAddMoreLine.length; i++) {
        total = Number(items.showAddMoreLine[i].packages) + Number(total);
      }
      this.value.showAddMore[index].total_packages = total;
    },
    handleAddCargo() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        showAddMoreLine: [
          {
            id: randomID2,
            hasDelete: false,
            gross_weight: null,
            volume: null,
            packages: null,
            dimension: {
              lenght: null,
              width: null,
              height: null,
            },
          },
        ],
        total_packages: 0,
        gross_weight_total: 0,
        volume_total: 0,
        commodity_type: null,
        commodity: null,
      };
      this.value.showAddMore.push(newElement);
    },
    handleDeleteCargo(id) {
      this.value.showAddMore = this.value.showAddMore.filter(
        (item) => item.id !== id
      );
    },
    handleAddLine(id) {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const index = this.value.showAddMore.findIndex((item) => item.id === id);

      if (index !== -1) {
        this.value.showAddMore[index].showAddMoreLine.push({
          id: randomID,
          hasDelete: true,
          gross_weight: null,
          volume: null,
          packages: null,
          dimension: {
            lenght: null,
            width: null,
            height: null,
          },
        });
      }
    },
    handleDeleteLine(id, id2) {
      for (let i = 0; i < this.value.showAddMore.length; i++) {
        const currentObj = this.value.showAddMore[i];
        if (currentObj.id === id) {
          for (let j = 0; j < currentObj.showAddMoreLine.length; j++) {
            const lineCurrent = currentObj.showAddMoreLine[j];
            if (lineCurrent.id === id2) {
              currentObj.total_packages -= lineCurrent.packages;
              currentObj.volume_total -= lineCurrent.volume;
              currentObj.gross_weight_total -= lineCurrent.gross_weight;
            }
          }

          currentObj.showAddMoreLine = currentObj.showAddMoreLine.filter(
            (item) => item.id !== id2
          );
        }
      }
    },
  },
  watch: {
    // "showAddMore.volume_total": function (n, o) {},
    // showAddMore: {
    //     deep: true,
    //     handler(n, o) {
    //         this.value.cargo_details = n;
    //     },
    // },
  },
  mounted() {
    if (this.value?.showAddMore?.length > 0) {
      this.value.showAddMore[0]?.commodity_type == null
        ? (this.value.showAddMore[0].commodity_type = this.value.goods_type)
        : null;
      this.value.showAddMore[0]?.commodity == null
        ? (this.value.showAddMore[0].commodity = this.value.mo_ta)
        : null;
    }
  },
};
</script>

<style lang="scss">
.cargo-details {
  z-index: 10;
  position: relative;
  .custom-add-line {
    cursor: pointer;
  }
  .mt-10 {
    padding: 0;
    margin-top: 10px;
  }
  label {
    color: #000000;
    font-weight: 600;
  }
  .customTotal {
    width: 100%;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    padding-left: 10px;
    height: 38px;
    border-radius: 5px;
    color: #000000;
  }
  .select2-selection--single .mx-input {
    border: none !important;
  }
  .custom-delete {
    :hover {
      opacity: 0.7;
    }
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 45px;
  }
  .form-control {
    border: none !important;
  }
  .b-card-bg {
    padding-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: auto;
    z-index: 10;
    @media (max-width: 992px) {
      height: 450px;
    }
    .custom-grid {
      flex: 0 0 19.5%;
      max-width: 19.3%;
      @media (max-width: 992px) {
        flex: 0 0 50%;
        max-width: 50%;
        margin: 0 0px;
      }
      .flex {
        display: flex;
        gap: 5px;
      }
    }
    @media (max-width: 992px) {
      height: 450px;
    }
  }
  .add-more-cargo {
    background-color: white;
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: -85px;
    z-index: 1;
    display: flex;
    align-items: end;
    justify-content: start;
    .select-add {
      color: #28938d;
      position: absolute;
      cursor: pointer;
      font-size: medium;
      font-weight: 600;
      bottom: 20px;
      left: 40px;
    }
  }
  .select2-selection .select2-selection--single {
    border: none !important;
  }
  .select2-selection--single:before {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
  .select2-selection--single {
    border: none !important;
  }
  //   .select2 {
  //     height: 28px !important;
  //   }
}
</style>
